import React from 'react';

const SIZE_MAP = {
  xs: { width: 96, height: 32 },
  sm: { width: 132, height: 44 },
  md: { width: 168, height: 56 },
  lg: { width: 207, height: 69 },
};

export default function BrandMark({
  variant = 'wordmark',
  theme = 'light',
  size = 'md',
  framed = false,
  className = '',
}) {
  const dimensions = SIZE_MAP[size] || SIZE_MAP.md;
  const isDark = theme === 'dark';
  const showWordmark = variant === 'wordmark';
  const needsFrame = framed || isDark;
  const width = showWordmark ? dimensions.width : dimensions.height;
  const height = dimensions.height;
  const label = showWordmark ? 'Hola Pay' : 'Hola Pay — Pay';

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center ${needsFrame ? 'rounded-xl bg-white p-1 shadow-sm ring-1 ring-black/10' : ''} ${className}`}
      role="img"
      aria-label={label}
    >
      {showWordmark && (
        <img
          src="/holapay-mascot-logo.png"
          alt=""
          aria-hidden="true"
          width={width}
          height={height}
          className="block object-contain"
        />
      )}
      <svg
        className={showWordmark ? 'hidden' : undefined}
        width={width}
        height={height}
        viewBox={showWordmark ? '0 0 208 62' : '0 0 62 62'}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {showWordmark && (
          <text
            x="0"
            y="43"
            fill={isDark ? '#FFFDF5' : '#23282B'}
            fontFamily="Bricolage Grotesque, Manrope, sans-serif"
            fontSize="42"
            fontWeight="800"
            letterSpacing="-2"
          >
            HOLA
          </text>
        )}
        <path
          d={showWordmark ? 'M139 9H198C203.523 9 208 13.477 208 19V40C208 45.523 203.523 50 198 50H175L165 59V50H149C143.477 50 139 45.523 139 40V9Z' : 'M4 4H55C59.418 4 62 7.582 62 12V40C62 44.418 59.418 47 55 47H35L25 58V47H11C6.582 47 4 44.418 4 40V4Z'}
          fill="#F5D547"
        />
        <text
          x={showWordmark ? '148' : '12'}
          y={showWordmark ? '37' : '33'}
          fill="#23282B"
          fontFamily="Bricolage Grotesque, Manrope, sans-serif"
          fontSize={showWordmark ? '22' : '21'}
          fontWeight="800"
          letterSpacing="-0.8"
        >
          PAY
        </text>
      </svg>
    </span>
  );
}